
import React, { useContext } from 'react';
import LoaderContext from '../context/LoaderContext';
import './loader.css';

const GlobalLoader = () => {
  const { loading } = useContext(LoaderContext);

  if (!loading) return null;

  return (
    <div className="global-loader">
      <div className="spinner">Loading...</div>
    </div>
  );
};

export default GlobalLoader;
